module.exports = __webpack_public_path__ + "static/img/jd7.f93cefd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/jd7.jpg
// module id = E+xN
// module chunks = 1